import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MemoDialogComponent } from './memo-dialog/memo-dialog.component';
import { FullScreenDialogService } from '@headpower/components';

@Component({
    selector: 'app-memo',
    templateUrl: './memo.component.html',
    styleUrls: ['./memo.component.scss']
})
export class MemoComponent implements OnInit {
    @Input() memo: string;
    @Input() mobile: boolean = false;
    @Input() type: string = '';
    @Output() memoChange = new EventEmitter<{ action: string; memo: any; }>();

    constructor(
        public dialog: MatDialog,
        private fullScreenDialog: FullScreenDialogService
    ) { }

    ngOnInit() { }

    public openMemoDialog() {
        let dialogRef;
        let dialogData = {
            memo: this.memo,
            mobile: this.mobile
        }

        if (!this.mobile) {
            dialogRef = this.dialog.open(MemoDialogComponent, {
                width: '720px',
                disableClose: true,
                data: { dialogData }
            });
        } else {
            dialogRef = this.fullScreenDialog.open(MemoDialogComponent, {
                maxHeight: '100vh',
                data: {
                    dialogData,
                    dialogTitle: 'default.memo',
                    actionLabel: 'default.save'
                }
            });
        }

        dialogRef.afterClosed()
            .subscribe(res => {
                if (res !== undefined) {
                    this.memoChange.emit({ action: 'change', memo: res });
                }
            });
    }

}
